/* eslint-disable react/require-default-props */
import React, {
  Suspense,
  useContext,
  useState,
  useEffect,
  useCallback,
} from 'react';
import PropTypes from 'prop-types';
import { cn } from '@express-labs/raven-tools';

import NotificationCard from './components/Bag/subcomponents/NotificationCard/NotificationCard';
import bagAnimation from '../../assets/AddToBag.png';
import useWindowSize from '../../hooks/useWindowSize/useWindowSize';
import s from './Header.module.scss';
import { MAX_MOBILE_WIDTH } from '../../constants';
import { HeaderDynamicContext } from '../../contexts/HeaderDynamicData/HeaderDynamicData';
import getFromStorage from '../../helpers/storage/storage';
import MemberWalletHeader from './components/MemberWalletHeader';
import { analyze } from '../../helpers';

const MobileHeader = React.lazy(
  () => import(/* webpackChunkName: "MobileChunk" */ './MobileHeader'),
);
const DesktopHeader = React.lazy(
  () => import(/* webpackChunkName: "DesktopChunk" */ './DesktopHeader'),
);

function Header({
  memberWalletEnhancement,
  memberWalletHeader,
  addToBagFlyoutEnabled,
  ...others
}) {
  const { width } = useWindowSize();
  const { customer } = useContext(HeaderDynamicContext);
  const { loginStatus } = customer ?? {};
  const [showNotification, setShowNotification] = useState(false);
  const [rewardsToolTip, setRewardsToolTip] = useState(false);

  /* istanbul ignore next */
  const onRequestClose = useCallback(() => {
    setShowNotification(false);
  }, []);

  useEffect(() => {
    analyze({
      name: 'headerReady',
    });
  }, []);

  useEffect(() => {
    const handleNotification = () => {
      setShowNotification(!showNotification);
    };
    window.addEventListener('cartItemAdd', handleNotification);
    return () => {
      window.removeEventListener('cartItemAdd', handleNotification);
    };
  }, [showNotification]);

  useEffect(() => {
    const { hasStorage } = window;
    /* istanbul ignore if */
    if (hasStorage && (loginStatus || getFromStorage('loyaltyWarmStateData'))) {
      const localStorageTooltipState =
        window.sessionStorage.getItem('tooltipState') || 'null';
      if (localStorageTooltipState === 'null') {
        setRewardsToolTip(true);
      }
    }
  }, [loginStatus]);

  const showMemberWalletHeader = () => {
    const href = window.location.pathname;
    if (href.indexOf('/bag') !== -1) return false;
    if (href.indexOf('/checkout') !== -1) return false;
    return true;
  };

  return (
    <div
      aria-label="header"
      className={s.header}
      data-count={others['data-count']}
    >
      {Boolean(width) && width <= MAX_MOBILE_WIDTH && (
        <div className={s.mobile} id="mobile-header" aria-label="mobile-header">
          <Suspense fallback={<div />}>
            <MobileHeader
              windowInnerWidth={width}
              displayRewardsToolTip={rewardsToolTip}
            />
          </Suspense>
        </div>
      )}
      <div
        className={cn(
          s.desktop,
          Boolean(width) && width <= MAX_MOBILE_WIDTH && s.hidden,
        )}
        aria-label="desktop-header"
      >
        <Suspense fallback={<div />}>
          <DesktopHeader displayRewardsToolTip={rewardsToolTip} />
        </Suspense>
      </div>
      {!memberWalletEnhancement &&
        memberWalletHeader &&
        showMemberWalletHeader() && <MemberWalletHeader />}
      {!addToBagFlyoutEnabled && (
        <NotificationCard
          show={showNotification}
          onRequestClose={onRequestClose}
          imageSrc={bagAnimation}
        />
      )}
    </div>
  );
}

Header.propTypes = {
  dataCount: PropTypes.string,
  memberWalletEnhancement: PropTypes.bool,
  memberWalletHeader: PropTypes.bool,
  addToBagFlyoutEnabled: PropTypes.bool,
};

export default Header;
